import { ref } from 'vue'
import {
  CODE_REG_EXP,
  EMAIL_VALID_REG_EXP,
  LABEL_REG_EXP,
  NUMBER_REG_EXP,
  PIN_REG_EXP,
  RECOVERY_CODE_REG_EXP,
} from '@/const'

export function useInput() {
  const isError = ref(false)
  const inputValue = ref('')
  const isNotNumber = ref(false)

  /**
   * 이름 수정 -> 제한 없이 10자 이내
   */
  const onInputDefault = (value: string) => {
    inputValue.value = value.trim()
  }

  /**
   * 계정 추가 -> 14자 이내, 첫 글자는 영문만, 두번째부터 영문, 숫자, 특수문자
   */
  const onInputLabel = (value: string) => {
    const isInvalidInput = !LABEL_REG_EXP.test(value) && value.trim() !== ''
    isError.value = isInvalidInput
    inputValue.value = value
  }

  /**
   * 핀 번호 -> 숫자만 6~8자 이내
   */
  const onInputPin = (value: string) => {
    const isInvalidType = !NUMBER_REG_EXP.test(value) && value.trim() !== ''
    const isInvalidInput = !PIN_REG_EXP.test(value)

    isNotNumber.value = isInvalidType
    isError.value = isInvalidInput
    inputValue.value = value
  }

  /**
   *
   * OTP 코드 -> 숫자만 6자 이내
   */
  const onInputCode = (value: string) => {
    value = value.slice(0, 6)
    const isInvalidType = !NUMBER_REG_EXP.test(value) && value.trim() !== ''
    const isInvalidInput = !CODE_REG_EXP.test(value)

    isNotNumber.value = isInvalidType
    isError.value = isInvalidInput
    inputValue.value = value
  }

  const onInputRecoveryCode = (value: string) => {
    isError.value = !RECOVERY_CODE_REG_EXP.test(value) && value.trim() !== ''
    inputValue.value = value
  }

  /**
   * 이메일 -> 이메일 형식
   */
  const onInputEmail = (value: string) => {
    const isInvalidInput =
      !EMAIL_VALID_REG_EXP.test(value) && value.trim() !== ''
    isError.value = isInvalidInput
    inputValue.value = value
  }

  return {
    isError,
    inputValue,
    isNotNumber,
    onInputDefault,
    onInputLabel,
    onInputPin,
    onInputRecoveryCode,
    onInputCode,
    onInputEmail,
  }
}
